import { onBeforeUnmount } from 'vue'
import cookie from 'js-cookie'
import { TOKEN } from '@/enum'
import { useEnv } from '@/hooks/useEnv'
const isSSr = import.meta.env.SSR
const { VITE_APP_TEST_COOKIE_API } = useEnv()
export const gotoLogin = () => {
  if (isSSr) return
  location.href = `${import.meta.env.VITE_APP_LOGIN_URI}login?from=${encodeURIComponent(
    location.href,
  )}`
}

export const gotoRegister = () => {
  if (isSSr) return
  location.href = `${import.meta.env.VITE_APP_LOGIN_URI}register?from=${encodeURIComponent(
    location.href,
  )}`
}

type Fn = () => void
export const countDown = (
  interCallback: (i: number) => void | null,
  delay: number,
  startCount: number,
  finallyCallback: Fn,
) => {
  const timer = setInterval(() => {
    startCount--
    if (!startCount) {
      clear()
      finallyCallback && finallyCallback()
      return
    }
    interCallback && interCallback(startCount)
  }, delay)
  const clear = () => clearInterval(timer)
  onBeforeUnmount(clear)
}

type GlobalThis = typeof globalThis & { cookies: Record<string, string | null> }

export const token = () => {
  return cookie.get(TOKEN)
}
type cookieConfig = {
  expires?: number
  path?: string
  domain?: string
}
export const setToken = (key: string, token: string) => {
  const config: cookieConfig = { expires: 7, path: '/' }
  cookie.set(key, token, {
    ...config,
    domain: VITE_APP_TEST_COOKIE_API,
  })
}

function getSubdomain() {
  try {
    let subdomain = ''
    const key = `mh_${Math.random()}`
    const expiredDate = new Date(0)
    const { domain } = document
    const domainList = domain.split('.')

    const reg = new RegExp(`(^|;)\\s*${key}=12345`)
    const ipAddressReg =
      /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/

    // 若为 IP 地址、localhost，则直接返回
    if (ipAddressReg.test(domain) || domain === 'localhost') {
      return domain
    }

    const urlItems = []
    urlItems.unshift(domainList.pop())

    while (domainList.length) {
      urlItems.unshift(domainList.pop())
      subdomain = urlItems.join('.')

      const cookie = `${key}=12345;domain=.${subdomain}`
      document.cookie = cookie

      if (reg.test(document.cookie)) {
        document.cookie = `${cookie};expires=${expiredDate}`
        break
      }
    }

    return subdomain || document.domain
  } catch (e) {
    return document.domain
  }
}

export const removeToken = () => {
  if (import.meta.env.SSR) {
    ;(global as GlobalThis).cookies[TOKEN] = null
  }
  const domain = getSubdomain()
  cookie.remove(TOKEN, { path: '/', domain })
}

/**
 * @description: 去抖
 * @param {function} fn 回调函数
 * @param {number} delay 延迟时间
 * @return {*}
 */
export const debounce = (fn: () => void, delay?: number) => {
  let time: ReturnType<typeof setTimeout>
  return () => {
    if (time) {
      clearTimeout(time)
    }
    time = setTimeout(() => {
      fn && fn()
    }, delay || 200)
  }
}

/**
 * @description: 节流
 * @param {function} fn 回调函数
 * @param {*} delay 延迟时间
 * @param {*} immediate	即时
 * @return {*}
 */
export const throttle = (fn: () => void, delay = 200, immediate = false) => {
  let timer: any = null
  return (...args: any) => {
    if (timer) clearInterval(timer)
    if (immediate) {
      if (!timer) fn.apply(this, args)
      timer = setTimeout(() => {
        timer = null
      }, delay)
    } else {
      timer = setTimeout(() => {
        fn.apply(this, args)
      }, delay)
    }
  }
}
/**
 * @description: 路由携带参数进行回跳
 * @param {string} url 回跳 路径
 */
export const urlJumpBack = (url: string) => {
  window.location.href = decodeURIComponent(url)
}

export const insideIframe = () => {
  return window.self !== window.top
}
